<template>
    <div class="con" :class="{'dark':active2}">
        <div class="main">
            <div class="c1">
                <div>{{$t('home').text0}}</div>
                <div>
                    <span></span>
                    <span @click="changeLan('zh-CH')">中文版</span>
                    <span @click="changeLan('en')">ENGLISH</span>
                </div>
            </div>
            <div class="c2">
                <div class="left">
                    <a href="/index.html"><img src="../assets/azf/topLogo.png" alt=""></a>
                </div>
                <div class="right">
                <div>
                    <input type="text" v-model="proName" @keyup.enter="goPro">
                    <i class="iconfont icon-sousuo" @click="goPro"></i>
                </div>
                    <ul>
                        <a href="/index.html" :class="page === 'home' ? 'showLine' : ''">  <li >{{$t('top')[0]}}</li></a>
                        <a href="/about.html" :class="page === 'about' ? 'showLine' : ''"><li >{{$t('top')[1]}}
                        <span>®</span>
                        </li></a>
                        <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''"><li >{{$t('top')[2]}}</li></a>
                        <a href="/faq.html" :class="page === 'faq' ? 'showLine' : ''"><li >{{$t('top')[3]}}</li></a>
                        <a href="/tele.html" :class="page === 'tele' ? 'showLine' : ''"><li >{{$t('top')[4]}}</li></a>
                        <a href="/contact.html" :class="page === 'contact' ? 'showLine' : ''"><li >{{$t('top')[5]}}</li></a>
                    </ul>
                </div>
            </div>
        </div>

        <div class="top animated fadeInUp">
            <a href="/index.html"><img class="mImg" src="../assets/azf/topLogo.png" alt=""></a>
            <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
                <span class="burger"></span>
                <span class="burger"></span>
                <span class="burger"></span>
            </div>
        </div>
        <div class="menuBox" :class="{open: menuOpen}">
            <a href="/index.html" :class="page === 'home' ? 'showLine' : ''">  <li >{{$t('top')[0]}}</li></a>
            <a href="/about.html" :class="page === 'about' ? 'showLine' : ''"><li >{{$t('top')[1]}}
                <span>®</span>
            </li></a>
            <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''"><li >{{$t('top')[2]}}</li></a>
            <a href="/faq.html" :class="page === 'faq' ? 'showLine' : ''"><li >{{$t('top')[3]}}</li></a>
            <a href="/tele.html" :class="page === 'tele' ? 'showLine' : ''"><li >{{$t('top')[4]}}</li></a>
            <a href="/contact.html" :class="page === 'contact' ? 'showLine' : ''"><li >{{$t('top')[5]}}</li></a>
            <div class="lan">
                <span @click="changeLan('zh-CH')">中文版</span>
                <span @click="changeLan('en')">ENGLISH</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import { setup } from "../local/index"
    export default {
        name: "first",
        data(){
            return{
                proName:'',
                menuOpen:false,
                active2:false,
                scrollbar:'',
                list:[
                    "HOME",
                    "ABOUT US",
                    "PRODUCTS",
                    "FAQ",
                    "NEW ARRIVALS",
                    "CONTACT US",
                ]
            }
        },
        props:['page'],
        // watch: {
        //     $route: 'getScrollbar'
        // },
        mounted(){
            this.$nextTick(()=>{
                this.getScrollbar()
            })
        },
        methods:{
            changeLan(n){
                this.$i18n.locale = n
                window.localStorage.setItem('language',n)
                setup(n);
                window.location.reload()
            },
            goPro(){
                const link = `/pro.html`
                // const link = `/sample.html?pid=${this.project.ID}`
                window.open(link,'_self')
            },
            goto(n){
                this.menuOpen=false
                localStorage.setItem('index',n)
                if(n===0){
                    this.$router.push({path:'/'})
                }else if(n===1){
                    this.$router.push({path:'/about'})
                }else if(n===2){
                    this.$router.push({path:'/pro'})
                } else if(n===3){
                    this.$router.push({path:'/faq'})
                } else if(n===4){
                    this.$router.push({path:'/newsInfo'})
                }else{
                    this.$router.push({path:'/contact'})
                }
                // else if(n===4){
                //     this.$router.push({path:'/news'})
                // }else if(n===6){
                //     this.$router.push({path:'/contact'})
                // }else if(n===5){
                //     this.$router.push({path:'/human'})
                // }else {
                //     this.$router.push({path:'/about'})
                // }
            },
            scrollHeader(scrollTop){
                this.active2=scrollTop>200 ? true : false
            },
            getScrollbar(){
                this.$nextTick(()=>{
                    this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                    this.active2=false
                    this.select=parseInt(localStorage.getItem('index'))
                    let scrollHeader=this.scrollHeader
                    if(this.scrollbar){
                        this.scrollbar.addListener((status) => {
                            scrollHeader(status.offset.y)
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        position: fixed;
        top:0;
        left:0;
        z-index: 1000;
        .animated{
            animation-delay: 600ms;
        }
        .main{
            width:100%;
            .c1{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                div{
                    padding: 10px 0;
                    font-size: 14px;
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                }
                div:nth-child(1){
                    background-color: #67B233;
                    color:white;
                    width:10%;
                    padding-left: 10%;
                }
                div:nth-child(2){
                    background-color: #0068B7;
                    width:80%;
                    text-align: right;
                    padding-right: 10%;
                    span{
                        color:white;
                        vertical-align: middle;
                        padding-left: 20px;
                        cursor: pointer;
                        transition: all 1s;
                    }
                    span:hover{
                        color:#67B233;
                    }
                    span:nth-child(2){
                      position: relative;
                    }
                    span:nth-child(2)::before{
                        position: absolute;
                        content:'';
                        display: inline-block;
                        height:15px;
                        width:1px;
                        background-color: white;
                        left:8px;
                        top:2px;
                    }
                    span:nth-child(2)::after{
                        position: absolute;
                        content:'';
                        display: inline-block;
                        height:15px;
                        width:1px;
                        background-color: white;
                        right:-8px;
                        top:2px;
                    }
                }
            }
            .c2{
                width:100%;
                display: flex;
                flex-direction: row;
                background-color: #FFFFFF;
                .left{
                    margin-left: 9%;
                    padding: 25px 0;
                    img{
                        margin-top: 10px;
                        cursor: pointer;
                    }
                }
                .right{
                    width:50%;
                    margin-left: 21%;
                    display: flex;
                    flex-direction: column;
                    text-align: right;
                    padding-top: 15px;
                    div:nth-child(1){
                        position: relative;
                        input{
                            width: 250px;
                            height: 30px;
                            background: none;
                            outline: none;
                            border: none;
                            border-bottom: 1px solid #E3E3E3;
                            text-indent: 10px;
                        }
                        input:focus{
                            border-color:#E3E3E3 !important; ;
                        }
                        i{
                            font-size: 25px;
                            position: absolute;
                            right:2%;
                            top:0;
                            cursor: pointer;
                        }
                    }
                    ul{
                        list-style: none;
                        display: flex;
                        flex-direction: row;
                        color:white;
                        justify-content: space-between;
                        width:98%;
                        margin-top: 10px;
                        a{
                            font-size: 14px;
                            cursor: pointer;
                            transition: all 2s;
                            padding: 10px 5px;
                            padding-bottom:20px;
                            position: relative;
                            li{
                                transition: all 1s;
                                span{
                                    position: absolute;
                                    right:-5px;
                                    top:0;
                                    transition: all 1s;
                                }
                            }
                        }
                        a::before{
                            content:'';
                            position: absolute;
                            left:0;
                            bottom:0;
                            width:0;
                            height:2px;
                            background-color: #0068B7;
                            display: inline-block;
                            border-radius: 10px;
                            transition: all 600ms;
                        }
                        a:hover{
                            li{
                                color:#005FAC;
                                span{
                                    color:#005FAC;
                                }
                            }
                        }
                        a:hover::before{
                            width:100%;
                        }
                        .showLine{
                            li{
                                color:#005FAC;
                                span{
                                    color:#005FAC;
                                }
                            }
                        }
                        .showLine::before{
                            width:100%;
                        }
                    }
                }
            }

        }
        .top{
            display: none;
        }
        .menuBox{
            position: fixed;
            top: -100vh;
            left:0;
            height:100vh;
            width: 100%;
            background: rgba(0,104,183,.9);
            z-index: 1010;
            transition: .8s;
            display: block;
        }
        .menuBox a{
            display: block;
            font-size: 18px;
            color:white;
            width:100%;
            padding: 18px 0px;
            text-align: center;
            opacity: 0;
            transition: .8s;
            li{
                color:white;
                list-style: none;
            }
        }
        .menuBox .lan{
            flex-direction: column;
            align-items: center;
            width:100%;
            display: flex;
            span{
                color:white;
                margin-top: 15px;
                font-size: 18px;
            }
        }
        .menuBox.open{
            top:75px;
            padding-top: 30px;
            a{
                opacity: 1;
            }
        }
        @media screen and (min-width: 2200px){
            .main{
                ul{
                    width:60%;
                }
            }
        }
        @media screen and (max-width: 1440px) and (min-width: 1000px){
            .main{
                .c2{
                    .right{
                       margin-left: 10%;
                        width:59%;
                    }
                }
            }
        }
        @media screen and (max-width: 999px){
            .main{
                display: none;
            }
            .top{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width:100%;
                padding: 20px 0px;
                transition: all 2s;
                background-color: #fff;
                a{
                    margin-left: 18%;
                }
            }
            .mImg{
                height:36px;
                object-fit: cover;
                margin-left: 20px;
                display: block;
                transition: all 600ms;
            }
            .mImg2{
                height:50px;
                object-fit: cover;
                margin-left: 20px;
                display: none;
                transition: all 600ms;
            }
            .mNav{
                display: block;
                transition: .8s;
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 60px;
            }
            .mNav .burger{
                width: 32px;
                height: 4px;
                background-color: #0068B7;
                position: absolute;
                top: 28px;
                left: 50%;
                margin: 0px 0px 0px -16px;
                transform-origin: center;
                transition: .8s;
            }
            .mNav .burger:nth-of-type(2){
                top: 38px;
            }
            .mNav .burger:nth-of-type(3){
                top: 48px;
            }
            .mNav.active{
                background-color:#0068B7;
            }
            .mNav.active .burger{
                background-color: #fff;
            }
            .mNav.active .burger:nth-of-type(1){
                top: 35px;
                transform: rotate(225deg);
            }
            .mNav.active .burger:nth-of-type(2){
                opacity: 0;
            }
            .mNav.active .burger:nth-of-type(3){
                top: 35px;
                transform: rotate(-225deg);
            }
        }
    }
    .dark{
        .main{
            width:100%;
            margin-left: 0;
            margin-top: 0;
        }
        @media screen and (max-width:450px){
        }
    }
</style>